import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

export const StyledHeaderBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 1,
} as const;

export const StyledHeaderTitle = {
  variant: "h5",
  fontWeight: 700,
} as const;

export const StyledHeaderSubtitle = {
  variant: "body2",
  color: "text.secondary",
  sx: { mt: 0.5 },
} as const;

export const StyledLanguageStatsPaper = styled(Paper)(({ theme }) => ({
  padding: "20px",
  marginBottom: 0,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
  borderRadius: 8,
  height: "100%",
  boxSizing: "border-box" as const,
}));

export const StyledLanguageStatsLabel = {
  variant: "body2",
  fontWeight: 600,
  sx: { mb: 1 },
} as const;

export const StyledLanguageStatsStack = {
  direction: "row",
  spacing: 1,
  sx: { flexWrap: "wrap", gap: 1 },
} as const;

export const StyledSearchForm = {
  component: "form",
  sx: { display: "flex", gap: 1.5, mb: 3, alignItems: "center" },
} as const;

export const StyledGuidelinesGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 2,
  mb: 3,
} as const;

export const StyledGuidelineCard = styled(Paper)(() => ({
  padding: "20px",
  borderRadius: 8,
  cursor: "pointer",
  transition: "all 0.2s ease",
  height: "100%",
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  "&:hover": {
    boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
    transform: "translateY(-2px)",
  },
}));

export const StyledCardIconBox = {
  width: 48,
  height: 48,
  borderRadius: 1,
  bgcolor: "action.hover",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
} as const;

export const StyledCardMetadataGrid = {
  display: "grid",
  gridTemplateColumns: "4fr 1fr",
  gap: 1,
  pb: 1.5,
  borderBottom: "1px solid",
  borderColor: "divider",
} as const;

export const StyledPaginationStack = {
  direction: "row",
  justifyContent: "center",
  alignItems: "center",
  spacing: 2,
  sx: { mt: 3 },
} as const;
